import React from 'react';
import cn from 'classnames';

import './StyledCheckbox.scss';

type Props = {
  id?: string;
  name?: string;
  label?: string;
  className?: string;
  labelClassName?: string;
  value?: number | string | boolean;
  checked: boolean;
  message?: React.ReactElement;
  bigSize?: boolean;
  active?: boolean;
  onChange: Function;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
};

function StyledCheckbox({
  id,
  name,
  label,
  checked,
  value,
  onChange,
  bigSize = false,
  className = '',
  labelClassName = '',
  message,
  active = true,
  onFocus,
  onBlur,
}: Props) {
  const handleChange = e => onChange(value || e);

  return (
    <div
      className={cn(`styled-checkbox-container position-relative d-flex pl-3 ${className}`, {
        'styled-checkbox-container--disabled': !active,
      })}
    >
      <input
        type="checkbox"
        className={cn('styled-checkbox-container-input position-absolute w-0 h-0 mt-1', {
          'cursor-pointer': active,
          'styled-checkbox-container-input--big-size': bigSize,
        })}
        id={id}
        name={name}
        checked={checked}
        onChange={handleChange}
        disabled={!active}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {label && (
        <label className={`${labelClassName} mb-0 ml-2`} htmlFor={id}>
          {label}
        </label>
      )}
      <span
        className={cn('styled-checkbox-checkmark position-absolute', {
          'disabled-pointer': !active,
          'styled-checkbox-checkmark--big-size': bigSize,
        })}
      />
      <span className="ml-1 text-muted">{message}</span>
    </div>
  );
}

export default StyledCheckbox;
